import React, { Component } from 'react';
import '../css/social-button.css';

class SocialButton extends Component {

    handleClick = () => {
        window.open(this.props.link, '_blank');
    }

    render() { 
        return (
            <button className='social-button' onClick={this.handleClick}>
                <i className={`ph ph-${this.props.iconName}`}></i>
            </button>
        );
    }
}

export default SocialButton;